import { OutlinedTextFieldProps } from '@mui/material'
import { Box } from '@mui/system'
import { useState } from 'react'

import { v4 as uuidv4 } from 'uuid'
import LoginInput from './LoginInput'

export interface ILoginInputProps extends Partial<OutlinedTextFieldProps> {
  errorMessage?: string
}

const LoginPassword = (props: ILoginInputProps) => {
  const [displayPassword, setDisplayPassword] = useState(false)

  return (
    <LoginInput
      {...props}
      id={`login-password-${uuidv4()}`}
      type={displayPassword ? 'text' : 'password'}
      InputProps={{
        ...props.InputProps,
        startAdornment: (
          <Box sx={{ color: 'common.accent', fontSize: '16px', mr: '10px' }}>
            <i className="fa-light fa-key" />
          </Box>
        ),
        endAdornment: (
          <Box
            sx={{ color: '#D1D1D1', fontSize: '16px', ml: '10px' }}
            onClick={() => setDisplayPassword((d) => !d)}
          >
            {displayPassword ? (
              <i className="fa-light fa-eye" />
            ) : (
              <i className="fa-light fa-eye-slash" />
            )}
          </Box>
        ),
      }}
    />
  )
}

export default LoginPassword
